
import { Link } from 'react-router-dom';
import { Box, styled } from '@mui/material';

const iconStyles = ({ theme }) => `
    color: ${theme.palette.text.primary};
    display: flex;
    text-decoration: none;
    width: 100%;
    margin: 0 auto;
    font-weight: ${theme.typography.fontWeightBold};
  `
const LogoWrapperLink = styled(Link)(
  iconStyles
);

const LogoWrapper = styled(Box)(iconStyles)

const LogoSignWrapper = styled(Box)(
  () => `
    width: 100%;
    height: 66px;
    display: flex;
    justify-content: center;
    align-items: center;
  `
);

function Logo({ light = false, clickable = false }) {
  // TODO: remove clickable
  const src = light ? '/logo_light.svg' : '/logo.svg'
  return <>{
    clickable ? <LogoWrapperLink to="/dashboard">
      <LogoSignWrapper>
        <img
          src={src}
          alt="Logo"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </LogoSignWrapper>
    </LogoWrapperLink> :
      <LogoWrapper>
        <LogoSignWrapper>
          <img
            src={src}
            alt="Logo"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </LogoSignWrapper>
      </LogoWrapper>
  }
  </>
}

export default Logo;


